/* unplugin-vue-components disabled */import { render } from "./OrderingTable.vue?vue&type=template&id=215a88d5&scoped=true"
import script from "./OrderingTable.vue?vue&type=script&lang=js"
export * from "./OrderingTable.vue?vue&type=script&lang=js"

import "./OrderingTable.vue?vue&type=style&index=0&id=215a88d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215a88d5"]])

export default __exports__